$(function(){
  $('body').on('click', '.next', function() {
    let lastName = $('input[name="text"]');
    let firstName = $('input[name="text-2"]');
    let email = $('input[name="email"]');
    let tel = $('input[name="phone"]');
    let type = $('select[name="select"]');
    let content = $('textarea[name="textarea"]');

    $('#last_name').val(lastName.val());
    $('#first_name').val(firstName.val());
    $('#email').val(email.val());
    $('#tel').val(tel.val());
    $('#type').val(type.val());
    $('#content').val(content.val());
  });
  
});